// extracted by mini-css-extract-plugin
module.exports = {"container":"Placeholder_container__3bisF","pos":"Placeholder_pos__XFeex","logo":"Placeholder_logo__8xuLB","desc":"Placeholder_desc__h-JbI"};